module.exports = __webpack_public_path__ + "static/media/StandingTallGREEK.5ab452f2.vtt";